import { getItemFromLocalStorage } from './getItemFromLocalStorage'

export const isProd =
  window.location.hostname === 'www.panenkafc.gg' ||
  window.location.hostname === 'panenkafc.gg' ||
  window.location.hostname === 'fan-club-a59.pages.dev' ||
  getItemFromLocalStorage('isProd')
